import { AxiosError } from "axios";

import { useLogout } from "@/hooks/useLogout";

export const useLogoutOnTwoFactorError = () => {
  const logout = useLogout();

  return (error: AxiosError) => {
    if (
      error.response?.status === 401 ||
      error.response?.status === 403 ||
      !error.response
    ) {
      logout();
    }
  };
};

export const downloadCodes = (backupCodes: number[]) => {
  const blob = new Blob([backupCodes.join("\n")], {
    type: "text/plain;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "backup-codes.txt";
  a.click();
  URL.revokeObjectURL(url);
};

export const copyCodesToClipboard = (backupCodes: number[]) =>
  navigator.clipboard.writeText(backupCodes.join("\n"));
